import { ChangeAttrName } from '@common/flare/change-attr-name.enum';

export const SetBlockTypeExcludeAttrs: string[] = [
  ChangeAttrName.ChangeIds,
  ChangeAttrName.ChangeList
];
